import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

declare global {
    interface Window {
        renderApp: any;
        unmountWorkspace: any;
    }
}

window.renderApp = (containerId: string) => {
    ReactDOM.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        document.getElementById(containerId)
    );
};

window.unmountWorkspace = (containerId: string) => {
    const containerElem = document.getElementById(containerId);
    if (containerElem) ReactDOM.unmountComponentAtNode(containerElem);
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
